import { render, staticRenderFns } from "./ProductsDetailsModal.vue?vue&type=template&id=6d2d0cca&scoped=true"
import script from "./ProductsDetailsModal.vue?vue&type=script&lang=js"
export * from "./ProductsDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ProductsDetailsModal.vue?vue&type=style&index=0&id=6d2d0cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2d0cca",
  null
  
)

export default component.exports